import { Injectable } from '@angular/core';
import {
    AbstractControl,
    AsyncValidator, AsyncValidatorFn,
    ValidationErrors,
} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {CarrierService} from '../services/carrier.service';
import {catchError, map, take} from 'rxjs/operators';

export class CompanyNumberValidator {
    static createValidator(carrierService: CarrierService, id: number): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors> => {
            return carrierService
                .isCompanyNumberExists(control.value, id)
                .pipe(
                    map((result: boolean) =>
                        result ? { companynumberexists: true } : null
                    )
                );
        };
    }
}


